import { setDisplayUnitSettings } from "../../utils/displayUnits";
import { setLaborUnitsEnabled } from "../../components/Bryntum/Gantt/laborChipTemplate";
import { setGanttChipOptions } from "../../components/Bryntum/Gantt/resourceChip/ganttChipOptions";
import { setGanttBarLayout } from "../../components/Bryntum/Gantt/barLabel/ganttBarLayout";
import { setSchedulingCalendarSettings } from "../../utils/schedulingCalendar";
import { getSessionTenant } from "../../global/sessionScope";

export const PORTFOLIO_DETAILS_CHANGED = "offolio.portfolioDetails.changed";

/** Feeds every module-level settings store the Gantt reads at render time. */
export const applyPortfolioDetails = (details) => {
  setDisplayUnitSettings(details);
  setLaborUnitsEnabled(details);
  setGanttChipOptions(details);
  setGanttBarLayout(details);
  setSchedulingCalendarSettings(details);
};

/**
 * Tells the other tabs that the portfolio settings were saved. Only a signal
 * goes through localStorage — each tab refetches with its own session, so a
 * tab signed in to another tenant never applies these settings.
 */
export const announcePortfolioDetailsChange = () => {
  try {
    localStorage.setItem(
      PORTFOLIO_DETAILS_CHANGED,
      JSON.stringify({ tenant: getSessionTenant(), at: Date.now() })
    );
  } catch {
    // Storage blocked: other tabs pick the settings up on their next load.
  }
};

/**
 * Calls `onChange` when another tab of the same tenant saved the portfolio
 * settings (the `storage` event never fires in the tab that wrote).
 * Returns the unsubscribe function.
 */
export const subscribePortfolioDetailsChange = (onChange) => {
  const onStorage = (event) => {
    if (event.key !== PORTFOLIO_DETAILS_CHANGED || !event.newValue) return;
    let tenant = null;
    try {
      ({ tenant } = JSON.parse(event.newValue));
    } catch {
      return;
    }
    if ((tenant || null) !== getSessionTenant()) return;
    onChange();
  };
  window.addEventListener("storage", onStorage);
  return () => window.removeEventListener("storage", onStorage);
};
